import { computed, effect, Injector, runInInjectionContext, signal } from "@angular/core";
import { CommonBaseModel, Pagination } from "app/shared/model";
import { DateTime } from "luxon";

/** FindVaultProducts */
export class VaultProductsFilter implements IVaultProductsFilter {
    /** s:string */
    filter: FormVaultFilter = new FormVaultFilter();
    /** s:string */
    pagination: Pagination = new Pagination();

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};

        data["filter"] = JSON.stringify(this.filter);
        data["pagination"] = JSON.stringify(this.pagination);
        return data;
    }
}

export interface IVaultProductsFilter {
    /** s:string */
    filter: FormVaultFilter;
    /** s:string */
    pagination: Pagination;
}

export class FormVaultFilter implements IFormVaultFilter {
    SearchTerm: string = '';
    Categories: string[] = [];
    OrganisationHandle: string = '';
    FormIds: string[] = [];
}

export interface IFormVaultFilter {
    SearchTerm: string;
    Categories: string[];
    OrganisationHandle: string;
}

export class GetVaultProductResult extends CommonBaseModel {
    success: boolean;
    product: ProductListItem;
    categories: string[] | undefined;
    organisationRelativeUrl: string; // { [key: string]: string; } | undefined;

    init(_data: any): this {
        super.init(_data);
        this.product = (new ProductListItem()).init(_data["Product"]);
        this.initArray(this, 'categories', _data['Categories']);
        return this;
    }
}

export class ProductSearchResult extends CommonBaseModel {
    success: boolean;
    pagination: Pagination | undefined;
    products: ProductListItem[] | undefined;
    categories: string[] | undefined;
    organisationsRelativeUrl: { [key: string]: string; } | undefined;

    init(_data?: any): this {
        super.init(_data);

        this.pagination = _data["Pagination"] ? (new Pagination()).init(_data["Pagination"]) : undefined;

        let products = _data["Products"];
        this.products = [];
        if (Array.isArray(products)) {
            for (let item of products) {
                if (!item) {
                    continue;
                }

                this.products.push((new ProductListItem()).init(item));
            }
        }

        super.initArray(this, "categories", _data["Categories"]);

        let urlsObj = _data["OrganisationsRelativeUrl"];
        if (urlsObj) {
            this.organisationsRelativeUrl = {} as any;
            for (let key in urlsObj) {
                if (urlsObj.hasOwnProperty(key) && urlsObj[key]) {
                    this.organisationsRelativeUrl![key] = urlsObj[key];
                }
            }
        }

        return this;
    }
}

export class ProductListItem extends CommonBaseModel {
    static FAVOURITE_KEY = 'FAVOURITES';

    id!: string | undefined;
    productId!: string | undefined;
    canStartApplication!: boolean;
    organisationId!: string | undefined;
    roles: string[] = [];
    publicAccess!: boolean;
    name!: string | undefined;
    avatar: { HasAvatar: boolean } | undefined;
    avatarUrl: string = '';
    description: string | undefined;
    categories: string[] = [];
    activeDate: DateTime;
    expiryDate: DateTime;
    themeName: string | undefined;
    nonElectronicSubmission!: boolean;
    accessibleOffline!: boolean;
    archived!: boolean;
    formVaultAccessible!: boolean;
    version!: number;

    savedOffline = signal<boolean>(false);
    favourite = signal<boolean>(false);

    // keyChar: represents the grouping character when no avatar exists
    keyChar: string = '?';
    // groupKey: Used for sorting and grouping of form-vault list items.
    groupKey = computed<string>(() => {
        return this.favourite() ? ProductListItem.FAVOURITE_KEY : this.keyChar;
    });

    init(_data?: any): this {
        super.init(_data);
        // this.id = _data["_id"]["$oid"];

        this.initArray(this, 'roles', _data['Roles']);
        this.initArray(this, 'categories', _data['Categories']);

        // this.activeDate = _data["ActiveDate"] ? DateTime.fromMillis(_data["ActiveDate"]["$date"]) : <any>undefined;
        // this.expiryDate = _data["ExpiryDate"] ? DateTime.fromMillis(_data["ExpiryDate"]["$date"]) : <any>undefined;

        if (!this.canStartApplication) {
            this.canStartApplication = this.publicAccess;
        }

        this.updateKeys();
        return this;
    }

    private updateKeys() {
        let key = this.name ? this.name.toUpperCase().charAt(0) : '?';
        if (!/[a-z\d]/i.test(key)) {
            key = '?';
        }

        if (/\d/.test(key)) {
            key = '#';
        }

        this.keyChar = key;
    }
}
